import { getYouTubeEmbedUrl } from '../lib/youtube';

export default function YouTubeEmbed({ url, title = 'YouTube video' }) {
  const embedUrl = getYouTubeEmbedUrl(url);
  if (!embedUrl) return null;

  return (
    <div className="youtube-embed-wrap">
      <iframe
        className="youtube-embed"
        src={embedUrl}
        title={title}
        loading="lazy"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowFullScreen
        referrerPolicy="strict-origin-when-cross-origin"
      />
    </div>
  );
}
